import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("g", { "clip-path": "url(#clip0_1010_573)" }, [
  /*#__PURE__*/_createVNode("path", {
    d: "M19.8717 4.96526C19.8552 4.84526 19.75 4.77885 19.6632 4.77153C19.5765 4.7643 17.7413 4.62827 17.7413 4.62827C17.7413 4.62827 16.4667 3.36293 16.3268 3.22287C16.1869 3.0829 15.9135 3.12547 15.8074 3.15671C15.7918 3.16131 15.5289 3.24243 15.0941 3.37698C14.6684 2.15183 13.917 1.02597 12.5951 1.02597C12.5586 1.02597 12.521 1.02745 12.4835 1.02958C12.1075 0.532406 11.6418 0.316406 11.2396 0.316406C8.16026 0.316406 6.68911 4.16586 6.22785 6.12202C5.0313 6.49279 4.18127 6.75638 4.0727 6.79049C3.40481 7 3.38368 7.02104 3.29598 7.65038C3.22998 8.12685 1.48242 21.6416 1.48242 21.6416L15.0998 24.193L22.4781 22.5968C22.4781 22.5968 19.888 5.08526 19.8717 4.96526ZM14.3415 3.60975L13.1892 3.96638C13.1897 3.88517 13.1901 3.80528 13.1901 3.71791C13.1901 2.95649 13.0844 2.34342 12.9148 1.85742C13.5959 1.9429 14.0495 2.71789 14.3415 3.60975ZM12.0699 2.00841C12.2592 2.4829 12.3824 3.16386 12.3824 4.08276C12.3824 4.12978 12.382 4.17276 12.3815 4.21624C11.6322 4.44835 10.8179 4.70035 10.0018 4.95317C10.4601 3.18474 11.319 2.3306 12.0699 2.00841ZM11.155 1.14235C11.2879 1.14235 11.4218 1.18747 11.5499 1.27567C10.5631 1.74005 9.50524 2.90964 9.05853 5.24528L7.17749 5.82786C7.70072 4.04635 8.94322 1.14235 11.155 1.14235Z",
    fill: "#95BF46"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M19.6633 4.7718C19.5766 4.76457 17.7414 4.62854 17.7414 4.62854C17.7414 4.62854 16.4669 3.3632 16.327 3.22314C16.2746 3.17103 16.204 3.14432 16.1302 3.13281L15.1006 24.1931L22.4783 22.5971C22.4783 22.5971 19.8881 5.08552 19.8718 4.96552C19.8553 4.84552 19.7502 4.77911 19.6633 4.7718Z",
    fill: "#5E8E3E"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M12.5953 8.84874L11.6855 11.555C11.6855 11.555 10.8884 11.1296 9.91129 11.1296C8.47885 11.1296 8.40677 12.0285 8.40677 12.255C8.40677 13.491 11.6287 13.9646 11.6287 16.8597C11.6287 19.1375 10.184 20.6042 8.23606 20.6042C5.89852 20.6042 4.70312 19.1494 4.70312 19.1494L5.32902 17.0815C5.32902 17.0815 6.55778 18.1364 7.59463 18.1364C8.27214 18.1364 8.54773 17.603 8.54773 17.2132C8.54773 15.601 5.90444 15.529 5.90444 12.8797C5.90444 10.65 7.50488 8.49219 10.7355 8.49219C11.9803 8.49219 12.5953 8.84874 12.5953 8.84874Z",
    fill: "white"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("defs", null, [
  /*#__PURE__*/_createVNode("clipPath", { id: "clip0_1010_573" }, [
    /*#__PURE__*/_createVNode("rect", {
      width: "24",
      height: "24",
      fill: "white",
      transform: "translate(0 0.251953)"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}